import { radioAnatomy as parts } from '@chakra-ui/anatomy';
import {
  createMultiStyleConfigHelpers,
  defineStyle,
} from '@chakra-ui/styled-system';
import { runIfFn } from '@chakra-ui/utils';

import { checkboxTheme } from './checkbox';

const { defineMultiStyleConfig, definePartsStyle } =
  createMultiStyleConfigHelpers(parts.keys);

const baseStyleControl = defineStyle((props) => {
  const controlStyle = runIfFn(checkboxTheme.baseStyle, props)?.control;

  return {
    ...controlStyle,
    borderRadius: 'full',
    _checked: {
      ...controlStyle?.['_checked'],
      borderColor: 'brand.500',
      bg: 'currentColor',

      _hover: {
        bg: 'currentColor',
      },

      _before: {
        content: `""`,
        display: 'inline-block',
        pos: 'relative',
        w: '60%',
        h: '60%',
        borderRadius: '50%',
        bg: 'brand.500',
      },
    },
  };
});

const baseStyle = definePartsStyle((props) => ({
  control: baseStyleControl(props),
}));

const sizes = {
  sm: definePartsStyle({
    control: { w: '5', h: '5' },
    label: { fontSize: 'sm' },
  }),
  md: definePartsStyle({
    control: { w: '6', h: '6' },
    label: { fontSize: 'md' },
  }),
  lg: definePartsStyle({
    control: { w: '7', h: '7' },
    label: { fontSize: 'lg' },
  }),
};

export const radioTheme = defineMultiStyleConfig({
  baseStyle,
  sizes,
  defaultProps: {
    colorScheme: 'primary',
  },
});
